var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 4.83333L9.90374 2.9741C9.63619 2.439 9.50241 2.17144 9.30283 1.97597C9.12634 1.80311 8.91362 1.67164 8.68008 1.59109C8.41599 1.5 8.11686 1.5 7.5186 1.5H4.33335C3.39993 1.5 2.93322 1.5 2.5767 1.68166C2.2631 1.84144 2.00813 2.09641 1.84834 2.41002C1.66669 2.76654 1.66669 3.23325 1.66669 4.16667V4.83333M1.66669 4.83333H14.3334C15.7335 4.83333 16.4336 4.83333 16.9683 5.10582C17.4387 5.3455 17.8212 5.72795 18.0609 6.19836C18.3334 6.73314 18.3334 7.4332 18.3334 8.83333V12.5C18.3334 13.9001 18.3334 14.6002 18.0609 15.135C17.8212 15.6054 17.4387 15.9878 16.9683 16.2275C16.4336 16.5 15.7335 16.5 14.3334 16.5H5.66669C4.26656 16.5 3.56649 16.5 3.03171 16.2275C2.56131 15.9878 2.17885 15.6054 1.93917 15.135C1.66669 14.6002 1.66669 13.9001 1.66669 12.5V4.83333ZM12.9167 13.5833L11.6667 12.3333M12.5 10.25C12.5 11.8608 11.1942 13.1667 9.58335 13.1667C7.97252 13.1667 6.66669 11.8608 6.66669 10.25C6.66669 8.63917 7.97252 7.33333 9.58335 7.33333C11.1942 7.33333 12.5 8.63917 12.5 10.25Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportTo);
export default __webpack_public_path__ + "static/media/report-to.b7f74ebff36e94bf4068a93983f0f484.svg";
export { ForwardRef as ReactComponent };